import { useEffect, useState } from "react";
import api from "@/lib/api";

// Renders a protected PDF inline (visual preview) as an object URL — no external open.
export default function AuthedPdf({ path, className = "" }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let active = true;
    let objUrl;
    api.get(path, { responseType: "blob" })
      .then((r) => {
        if (!active) return;
        objUrl = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
        setUrl(objUrl);
      })
      .catch(() => {});
    return () => { active = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);
  if (!url) return <div className={`animate-pulse bg-slate-800 ${className}`} />;
  const src = `${url}#toolbar=0&navpanes=0&view=FitH`;
  return (
    <object data={src} type="application/pdf" className={className}>
      <iframe title="Aperçu PDF" src={src} className="h-full w-full" />
    </object>
  );
}
